/** クライアント向け: 予約送信日時（30分刻み） */

export function toDatetimeLocalValue(date) {
  const d = date instanceof Date ? date : new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function getNextSchedulableSlot(from = new Date()) {
  const d = new Date(from.getTime() + 60_000);
  d.setSeconds(0, 0);
  const m = d.getMinutes();
  if (m > 0 && m < 30) d.setMinutes(30);
  else if (m > 30) {
    d.setHours(d.getHours() + 1);
    d.setMinutes(0);
  }
  return d;
}

export function roundToNearest30Minutes(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  d.setSeconds(0, 0);
  const m = d.getMinutes();
  if (m < 15) d.setMinutes(0);
  else if (m < 45) d.setMinutes(30);
  else {
    d.setHours(d.getHours() + 1);
    d.setMinutes(0);
  }
  return toDatetimeLocalValue(d);
}

export function isOn30MinuteBoundary(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return false;
  return d.getSeconds() === 0
    && d.getMilliseconds() === 0
    && (d.getMinutes() === 0 || d.getMinutes() === 30);
}
